import models.DomainGame
import models.GameAnalyticsCalculator
import models.GameAwardKind
import models.sevenLeaders

/** Plain-text companion to the visual recap for native share sheets and clipboard fallbacks. */
internal fun buildGameRecapShareText(game: DomainGame): String {
    val standings = game.players.sortedByDescending { it.points }
    val winner = standings.firstOrNull()
    val recap = game.recapStats

    return buildString {
        appendLine("BANKO table recap 🎲")
        winner?.let { appendLine("🏆 ${it.name} won with ${it.points} points") }
        if (standings.isNotEmpty()) {
            append("Final table: ")
            appendLine(standings.joinToString(" · ") { "${it.name} ${it.points}" })
        }
        recap.biggestPot?.let {
            appendLine("🔥 Biggest pot: ${it.points} in round ${it.roundNum}")
        }
        recap.biggestBank?.let {
            appendLine("🏦 Boldest bank: ${it.playerName} took ${it.points}")
        }
        recap.biggestBust?.let {
            appendLine("💥 Biggest bust: ${it.playerName} lost ${it.points}")
        }
        recap.sevenLeaders().firstOrNull()?.let { leader ->
            val leaders = recap.sevenLeaders().joinToString(" & ") { it.playerName }
            appendLine("7️⃣ Seven magnet: $leaders ×${leader.count}")
        }
        val analytics = GameAnalyticsCalculator.from(game)
        analytics.awards.firstOrNull { it.kind == GameAwardKind.IRON_NERVES }?.let { award ->
            val names = award.playerNames.joinToString(" & ")
            appendLine("🧊 Iron nerves: $names, banking after ${formatOneDecimal(award.value / 10.0)} rolls")
        }
        if (analytics.totals.rolls > 0) {
            with(analytics.totals) {
                appendLine("🎲 $rolls rolls · $banks banks · $busts busts")
            }
        }
        append("Run it back at ${InviteLinks.buildRecapUrl()}")
    }
}
